<button class="reusable-button background-white cursor-pointer" (click)="select()"
        [class.selected-button]="data.isButtonSelected && !isLogoutButton">{{data.key | translate}}</button>
